/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Link } from 'react-router-dom';
import Theme from '../../../theme';
import styled from 'styled-components';

export const GuestInformationBox = styled.div<{ itemsPerRow: number }>`
  display: grid;
  gap: 10px;
  background-color: ${Theme.colors.white.hexCode};
  border-radius: 12px;
  grid-template-columns: ${({ itemsPerRow }) => `repeat(${itemsPerRow}, 1fr)`};
  padding: 15px 20px;
`;

export const GuestInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
`;

export const GuestInformationTitle = styled.div`
  font-size: 12px;
  line-height: 12px;
  font-weight: 500;
  color: ${Theme.colors.overlay.hexCode};
`;

export const GuestInformationText = styled.div`
  font-size: 18px;
  line-height: 18px;
  font-weight: 700;
`;

export const GuestInformationIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: ${Theme.colors.ghostWhite.hexCode};
  margin-right: 15px;

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const LinkContainer = styled(Link)`
  display: flex;
  color: ${Theme.colors.quickActionButton.hexCode};
  text-decoration: none;
  text-align: end;
  justify-content: center;
  align-items: center;
  gap: 10px;

  > :nth-child(2) {
    font-size: 22px;
  }
`;

export const LinkText = styled.div`
  display: flex;
  height: 40px;
  justify-content: center;
  align-items: end;
  flex-direction: column;
  font-weight: 500;
`;

export const GuestInfoTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
